// Import images
import WebImage1 from '../images/web-project-1.jpg';
import WebImage2 from '../images/web-project-2.jpg';
import UIImage1 from '../images/ui-project-1.jpg';
import WorkImage from '../images/work-experience.jpg'; // create this image

export const projectsData = [
  {
    id: 1,
    title: 'UMS KPI System',
    category: 'Full-Stack Web Application',
    img: WebImage2,
    liveUrl: 'https://umskpi.nansuri.xyz',
    githubUrl: 'https://github.com/eki02',
  },
  {
    id: 2,
    title: 'UMS Organization System',
    category: 'Full-Stack Web Application',
    img: WebImage1,
    liveUrl: 'https://umsorg.nansuri.xyz',
    githubUrl: 'https://github.com/eki02',
  },
  {
    id: 3,
    title: 'ZabaGym',
    category: 'Laravel + Livewire System',
    img: UIImage1,
    liveUrl: 'https://zabagym.nansuri.xyz',
    githubUrl: 'https://github.com/eki02',
  },
  {
    id: 4,
    title: 'Work Experience',
    category: 'Internship & Professional Experience',
    img: WorkImage,
    liveUrl: 'https://yourdomain.com/work', // this will be your QR page
    githubUrl: '',
  },
];
